import { ArrowUpRight } from "lucide-react";
import { TriangleMark, WeaveWordmark, scrollToId } from "./Weave";

export default function Footer({ onJoin }) {
  return (
    <footer data-testid="editorial-footer" className="bg-footer text-paper">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:justify-between">
          <div className="max-w-sm">
            <div className="inline-flex flex-col items-start gap-3 rounded-2xl bg-paper p-4 sm:p-5">
              <img src="/logo.webp" alt="The Weave" className="h-9 w-auto" />
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-tealdark">
                Experience, rewoven
              </p>
            </div>
            <p className="mt-5 leading-relaxed text-paper/60">
              Business support with soul. The Weave Founder Academy opens April 2027 — helping
              founders thrive, not just survive.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-paper/40">The Academy</p>
              <ul className="mt-4 space-y-3 text-sm">
                {[
                  { label: "The shift", id: "shift" },
                  { label: "The programme", id: "programme" },
                  { label: "Why us", id: "why" },
                  { label: "Tuition", id: "tuition" },
                  { label: "FAQ", id: "faq" },
                ].map((l) => (
                  <li key={l.id}>
                    <button
                      data-testid={`footer-link-${l.id}`}
                      onClick={() => scrollToId(l.id)}
                      className="text-paper/75 transition-colors hover:text-wyellow"
                    >
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-paper/40">Get in touch</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li>
                  <a href="mailto:hello@wearetheweave.co.uk" className="text-paper/75 transition-colors hover:text-wyellow">
                    hello@wearetheweave.co.uk
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.wearetheweave.co.uk/academy"
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-1 text-paper/75 transition-colors hover:text-wyellow"
                  >
                    wearetheweave.co.uk
                    <ArrowUpRight className="h-3.5 w-3.5" />
                  </a>
                </li>
                <li>
                  <a href="/api/prospectus" target="_blank" rel="noreferrer" className="text-paper/75 transition-colors hover:text-wyellow">
                    Prospectus (PDF)
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-paper/40">Ready?</p>
              <button
                data-testid="footer-cta-join-waitlist"
                onClick={onJoin}
                className="mt-4 w-full rounded-full bg-wred px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-paper hover:text-ink"
              >
                Join the waitlist
              </button>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-paper/10 pt-8 text-xs text-paper/45 sm:flex-row sm:items-center">
          <p>© The Weave · The Founder Academy opens April 2027</p>
          <p>Founder first. Business second.</p>
        </div>
      </div>
    </footer>
  );
}
